import { simpleRequiredSelect, simpleNonRequiredSelect } from '@bit/wavfichacerta.fichacerta.fields-templates.select'
import { simpleRequiredText, simpleDisabledText } from '@bit/wavfichacerta.fichacerta.fields-templates.simple-text'
import { defaultCPF } from '../../../components/shared/form/fields'

const userTypeOptions = [
  { value: "", label: "Selecione" },
  { value: "ADICIONAL", label: "Adicional" },
  { value: "MASTER", label: "Master" },
]

const accessTypeOptions = [
  { value: "", label: "Selecione" },
  { value: "LOGIN_SENHA", label: "Login e senha" },
  { value: "SSO", label: "SSO" },
]

const acessoLuciaOptions = [
  { value: "", label: "Selecione" },
  { value: "0", label: "Não" },
  { value: "1", label: "Sim" },
]

export const alcadaLuciaSolicitacaoOptions = (whatsappCompartilhado = false) => {
  const options = [
    { value: "", label: "Selecione" },
    { value: "TODAS", label: "Todas" },
    { value: "MINHAS", label: "Minhas Solicitações", disabled: Boolean(whatsappCompartilhado) },
  ];
  // Select do bit não aplica option.disabled — remove Minhas quando compartilhado.
  if (whatsappCompartilhado) {
    return options.filter((option) => option.value !== "MINHAS");
  }
  return options;
}

export const alcadaLuciaColetaOptions = (whatsappCompartilhado = false) => {
  const options = [
    { value: "", label: "Selecione" },
    { value: "TODAS", label: "Todas" },
    { value: "MINHAS", label: "Minhas Coletas", disabled: Boolean(whatsappCompartilhado) },
    { value: "SEM_ALCADA", label: "Sem alçada" },
  ];
  if (whatsappCompartilhado) {
    return options.filter((option) => option.value !== "MINHAS");
  }
  return options;
}

export const hasAcessoLucia = (allValues = {}) => {
  return allValues.acesso_lucia === "1"
    || allValues.acesso_lucia === 1
    || allValues.acesso_lucia === true;
}

export const isWhatsappCompartilhado = (allValues = {}) => {
  const restrito = allValues.restrito
  return restrito === "0" || restrito === 0 || restrito === false;
}

export const validateAlcadaLuciaSolicitacao = (value, allValues) => {
  if (!hasAcessoLucia(allValues) || allValues.lucia_solicita_disponivel !== true) {
    return undefined;
  }

  if (!value) {
    return "Selecione a alçada LucIA Solicitação";
  }

  if (isWhatsappCompartilhado(allValues) && value === "MINHAS") {
    return "Com Whatsapp Compartilhado a alçada deve ser Todas";
  }

  return undefined;
}

export const validateAlcadaLuciaColeta = (value, allValues) => {
  if (!hasAcessoLucia(allValues) || allValues.lucia_coleta_disponivel !== true) {
    return undefined;
  }

  if (!value) {
    return "Selecione a alçada LucIA Coleta";
  }

  if (isWhatsappCompartilhado(allValues) && value === "MINHAS") {
    return "Com Whatsapp Compartilhado a alçada Coleta não pode ser Minhas Coletas";
  }

  return undefined;
}

/**
 * Espelha o popup do colaborador:
 * 1) Perfil / Tipo de acesso / Agente LucIA
 * 2) Nome
 * 3) CPF / Identidade / Órgão
 * 4) Função
 * (Tipo Acesso LucIA + alçadas + Whatsapp ficam em SecondLineFields)
 */
export default (editMode = false, loggedUser = false, typeUserEdit = "", luciaSolicitaDisponivel = false) => {
  const firstRowFields = [];

  if (!editMode) {
    firstRowFields.push(
      {...simpleRequiredSelect({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'tipo_usuario', label: 'Tipo de usuário' }), options: userTypeOptions},
    )
  }

  firstRowFields.push(
    {...simpleRequiredSelect({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'tipo_acesso', label: 'Tipo de acesso' }), options: accessTypeOptions},
  )
  if (luciaSolicitaDisponivel) {
    firstRowFields.push(
      {...simpleRequiredSelect({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'acesso_lucia', label: 'Agente IA – LucIA' }), options: acessoLuciaOptions},
    )
  }

  const nameRowFields = editMode
    ? [simpleDisabledText({ size: 'field-fc field-fc-sm field-fc-sm-12', name: 'nome', label: 'Nome' })]
    : [simpleRequiredText({ size: 'field-fc field-fc-sm field-fc-sm-12', name: 'nome', label: 'Nome' })]

  const docsRowFields = editMode
    ? [
        simpleDisabledText({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'cpf', label: 'CPF' }),
        simpleDisabledText({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'identidade', label: 'Identidade' }),
        simpleDisabledText({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'orgao_expedidor', label: 'Órgão expedidor' }),
      ]
    : [
        defaultCPF('field-fc field-fc-xs field-fc-sm-4'),
        simpleRequiredText({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'identidade', label: 'Identidade' }),
        simpleRequiredText({ size: 'field-fc field-fc-xs field-fc-sm-4', name: 'orgao_expedidor', label: 'Órgão expedidor' }),
      ]

  const funcaoRowFields = [
    simpleRequiredText({ size: 'field-fc field-fc-sm field-fc-sm-8', name: 'funcao', label: 'Função' }),
  ]

  return [
    { name: 'firstLine', fields: firstRowFields },
    { name: 'nameLine', fields: nameRowFields },
    { name: 'docsLine', fields: docsRowFields },
    { name: 'funcaoLine', fields: funcaoRowFields },
  ];
}
